import React from 'react';
import Modal from './Modal';

const DeleteConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirmer la suppression", 
  itemName,
  itemType = "élément",
  isDeleting = false
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      onSubmit={onConfirm}
      submitLabel={isDeleting ? "Suppression..." : "Supprimer"}
      submitColor="red"
      isSubmitting={isDeleting}
    >
      <div className="py-4">
        <div className="flex items-start">
          <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-red-100">
            <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <div className="ml-4">
            <p className="text-sm text-gray-500">
              Êtes-vous sûr de vouloir supprimer {itemName ? <span className="font-medium text-gray-700">"{itemName}"</span> : `cet ${itemType}`}? Cette action est irréversible et toutes les données associées seront définitivement supprimées.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationDialog;